module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.50-72.vue");


//////////////////
// WEBPACK FOOTER
// ./en/changelog/v2.1.0-rc.50.md
// module id = 489
// module chunks = 364